const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

class RangeView {
    defaultOptions() {
        return {
            'selector': '.view-supplier-range',
            'filterFormSelector': '.supplier-range-filter-form',
            'contentContainerSelector': '.supplier-range-content',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$filterForm = $(this.settings.filterFormSelector,this.$container);
        this.$content = $(this.settings.contentContainerSelector,this.$container);


        this.$selectSupplier = $('select[name="supplier"]',this.$filterForm);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.bindEvents();
    }

    bindEvents(){
        this.$selectSupplier.on("change",this.onSubmitFilterForm);
        this.$filterForm.on("submit",this.onSubmitFilterForm);
    }


    onSubmitFilterForm(event){
        event.preventDefault();
        event.stopPropagation();

        this.$content.html('');

        let supplierId = this.$selectSupplier.val();
        if(supplierId){
            this.loadSupplierContent(supplierId);
        }
    }


    loadSupplierContent(supplierId){
        var self = this;

        this.supplierId = parseInt(supplierId);

        this.$content
        .html('')
        .append(window.App.generateLoader());


        let queries = [
            this.buildRangeQuery(),
            this.buildSupplierAssociationQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildContent(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSupplierAssociationQuery(){
        var self = this;

        let parameters = {
            'filter': {
                'supplier': this.supplierId,
            }
        };

        let fields = [
            'restaurant { id name }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantSupplierAssociations',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildRangeQuery(){
        var self = this;

        let parameters = {
            'first': 10000,
            'orderBy': 'name',
            'dir': "ASC",
            'filter': {
                'root': true,
                'deliveredBySupplier': this.supplierId,
            }
        };

        let fields = [
            'id',
            'name',
            'suppliers { id }',
            'childs { id name suppliers { id } parent { id } childs { id name suppliers { id } parent { id } childs { id name suppliers { id } parent { id } } } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductRanges',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    getAllRestaurantIds(){
        let ids = [];
        for(var i in this.restaurantSupplierAssociations){
            let restaurant= this.restaurantSupplierAssociations[i].node.restaurant;
            ids.push(restaurant.id);
        }
        return ids;
    }

    buildContent(data){
        var self = this;

        this.ranges = data.supplierProductRanges.edges;
        this.restaurantSupplierAssociations = data.restaurantSupplierAssociations.edges;

        this.$content.html('');

        if(this.ranges.length <= 0){
            this.$content
            .append(
                $('<div/>')
                .addClass('alert alert-danger')
                .append(window.translate('app.supplier.range.noRange'))
            )
            return;
        }

        let $list = $('<div/>')

        this.$content.append($list);
        for(var r in this.ranges){
            let range = this.ranges[r];

            if(range.node && this.isSupplierRange(range.node)){
                let $container = this.buildRangeContainer(range.node);

                $list
                .append(
                    $('<div/>')
                    .addClass('white-box')
                    .append($container)
                )
            }
        }
    }

    buildRangeContainer(range){
        var self = this;

        let $container = $('<div/>')
        .addClass('range-container');


        let $btnEnableAll = $('<button/>')
        .addClass('btn btn-sm btn-success btn-enable-ranges')
        .attr('data-range',range.id)
        .append(window.translate('app.supplier.range.enableAll.label'))
        .on('click',function(event){
            self.enableAll(range.id)
        });


        $container
        .append(
            $('<div/>')
            .addClass('row mb-1')
            .append(
                $('<div/>')
                .addClass('col-8')
                .append(range.name)
            )
            .append(
                $('<div/>')
                .addClass('col-4 d-flex justify-content-end pb-2 pe-2')
                .append($btnEnableAll)
            )
        )


        if(range.childs && range.childs.length > 0){
            let $list = $('<ul/>')
            .addClass('list-unstyled');

            let $childContainer = $('<li/>')
            .addClass('');
            let orderedChilds = window.sortArrayOfObjectByProperty(range.childs,"name");
            for(var c in orderedChilds){
                let child = orderedChilds[c];
                if(child && this.isSupplierRange(child)){
                    let $child = this.buildRangeContainer(child);
                    $childContainer.append($child);
                }
            }
            $list.append($childContainer);

            $container
            .append(
                $('<div/>')
                .addClass('ps-2 pt-2 bg-light')
                .append($list)
            )
        }

        return $container;
    }

    isSupplierRange(range){
        for(var i in range.suppliers){
            let supplier = range.suppliers[i];
            if(supplier && supplier.id == this.supplierId){
                return true;
            }
        }
        return false;
    }

    enableAll(rangeId){
        var self = this;

        let $btns = $('.btn-enable-ranges');


        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'supplier': {
                'value': this.supplierId,
                'type': 'Int!'
            },
            'restaurants':{
                'value': this.getAllRestaurantIds(),
                'type': '[Int]'
            },
            'ranges':{
                'value': [rangeId],
                'type': '[Int]'
            },
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitRangesForRestaurants",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
                $btns.attr('disabled','disabled');
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,'success');
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
                $btns.removeAttr('disabled');
            }
        });
        mutation.execute();

    }
}

module.exports = RangeView;

